<template>
	<div data-tour-scope="documents">
		<v-main>
			<v-container fluid fill-height>
				<v-layout justify-center align-center>
					<v-card width="100%" outlined elevation-0>
						<v-toolbar flat class="border_bottom" shaped>
							<v-toolbar-title> {{ title }}</v-toolbar-title>
							<v-btn class="ml-6" outlined color="primary" data-tour="tutorial" @click="tour.start()"><v-icon left>mdi-school-outline</v-icon>Tutorial guidato</v-btn>

							<v-spacer />
							<v-toolbar-items shift>
								<!-- una sola azione possibile: il piu' porta dritto alla pagina, senza menu -->
								<v-btn v-if="!readOnly" elevation="0" text title="Consegna un documento" data-tour="add" @click="createItem">
									<v-icon>mdi-plus</v-icon>
								</v-btn>
							</v-toolbar-items>
						</v-toolbar>


						<!-- filtri in pagina: finiscono nell'URL, un refresh o il ritorno da una scheda li ritrova -->
						<v-col cols="12">
							<v-row data-tour="filters">
								<v-col cols="12" md="3">
									<v-menu v-model="menuPeriod" :close-on-content-click="false" transition="scale-transition" offset-y max-width="350px" min-width="auto">
										<template #activator="{ on, attrs }">
											<v-text-field
												:value="settings.filters.period"
												label="Periodo di riferimento"
												prepend-inner-icon="mdi-calendar"
												outlined
												dense
												readonly
												clearable
												hide-details
												v-bind="attrs"
												v-on="on"
												@click:clear="settings.filters.period = ''"
											></v-text-field>
										</template>
										<v-date-picker :value="settings.filters.period" type="month" no-title scrollable @input="pickPeriod"></v-date-picker>
									</v-menu>
								</v-col>
								<v-col v-if="receiversList.length > 0" cols="12" md="3">
									<v-autocomplete v-model="settings.filters.receiver" :items="receiversList" item-text="name" item-value="id" label="Destinatario" outlined dense clearable hide-details />
								</v-col>
								<v-col cols="12" md="3">
									<v-select v-model="settings.filters.downloaded" :items="downloadedOptions" label="Scaricato" outlined dense clearable hide-details />
								</v-col>
							</v-row>
						</v-col>

						<v-data-table
							:options.sync="settings.options"
							:headers="headers"
							:items="getItems"
							:server-items-length="total"
							must-sort
							class="elevation-0"
							:footer-props="{ 'items-per-page-options': listSize }"
							item-key="_id"
							data-tour="table"
							:hide-default-header="mobileCards"
							:class="{ 'table-cards': mobileCards }"
						>
							<template #body="{ items }">
								<!-- telefono: ogni riga diventa una card chiave/valore -->
								<tbody v-if="mobileCards" class="document-cards">
									<tr v-for="item in items" :key="item._id">
										<td :colspan="headers.length" class="px-3 py-1">
											<key-value-card :title="item.name || 'Senza titolo'" :fields="campiCard(item)">
												<template #actions>
													<v-menu top eager>
														<template #activator="{ on, attrs }">
															<v-btn icon small v-bind="attrs" color="primary" v-on="on" data-tour="row-menu">
																<v-icon>mdi-dots-vertical</v-icon>
															</v-btn>
														</template>
														<v-list>
															<template v-if="readOnly">
																<v-list-item link data-tour="row-show" @click="showItem(item)">
																	<v-list-item-title class="size9"> Visualizza </v-list-item-title>
																</v-list-item>
																<v-list-item link @click="downloadFile(item)">
																	<v-list-item-title class="size9"> Scarica </v-list-item-title>
																</v-list-item>
															</template>
															<template v-else>
																<v-list-item link data-tour="row-edit" @click="editItem(item)">
																	<v-list-item-title class="size9"> Modifica </v-list-item-title>
																</v-list-item>
																<v-list-item link data-tour="row-delete" @click="deleteItem(item)">
																	<v-list-item-title class="size9"> Elimina </v-list-item-title>
																</v-list-item>
															</template>
														</v-list>
													</v-menu>
												</template>
												<div data-tour="downloaded">
													<v-chip v-if="item.downloaded" label small color="green" text-color="white">
														<strong>Scaricato alle {{ new Date(item.downloaded_at).toLocaleString() }}</strong>
													</v-chip>
													<v-chip v-else label small color="red" text-color="white">
														<strong>Non scaricato</strong>
													</v-chip>
												</div>
											</key-value-card>
										</td>
									</tr>
									<tr v-if="!items.length">
										<td :colspan="headers.length" class="text-center grey--text py-6">Nessun documento</td>
									</tr>
								</tbody>
								<tbody v-else>
									<tr v-for="item in items" :key="`${item._id}`">
										<td class="pl-0 pr-0 ml-0 mr-0" style="width: 5px">
											<v-menu top eager>
												<template #activator="{ on, attrs }">
													<v-btn icon dark v-bind="attrs" color="primary" dense v-on="on" data-tour="row-menu">
														<v-icon dark> mdi-dots-vertical </v-icon>
													</v-btn>
												</template>
												<v-list>
													<template v-if="readOnly">
														<v-list-item link data-tour="row-show" @click="showItem(item)">
															<v-list-item-title class="size9"> Visualizza </v-list-item-title>
														</v-list-item>
														<v-list-item link @click="downloadFile(item)">
															<v-list-item-title class="size9"> Scarica </v-list-item-title>
														</v-list-item>
													</template>
													<template v-else>
														<v-list-item link data-tour="row-edit" @click="editItem(item)">
															<v-list-item-title class="size9"> Modifica </v-list-item-title>
														</v-list-item>
														<v-list-item link data-tour="row-delete" @click="deleteItem(item)">
															<v-list-item-title class="size9"> Elimina </v-list-item-title>
														</v-list-item>
													</template>
												</v-list>
											</v-menu>
										</td>
										<td class="text-left">
											{{ new Date(item.created_at).toLocaleString() }}
										</td>
										<td class="text-left">{{ item.name }}</td>
										<td class="text-left">
											{{ item.sender && item.sender.name }}
										</td>
										<td class="text-left">
											{{ item.receiver && item.receiver.name }}
										</td>
										<td data-tour="downloaded" class="text-left">
											<v-chip v-if="item.downloaded" label small color="green" text-color="white">
												<strong>Scaricato alle {{ new Date(item.downloaded_at).toLocaleString() }}</strong>
											</v-chip>
											<v-chip v-else label small color="red" text-color="white">
												<strong> Non scaricato</strong>
											</v-chip>
										</td>
									</tr>
									<tr v-if="!items.length">
										<td :colspan="headers.length" class="text-center grey--text py-6">Nessun documento</td>
									</tr>
								</tbody>
							</template>
						</v-data-table>
					</v-card>
					<v-snackbar v-model="snackbar.snackbar" :color="snackbar.color" :multi-line="snackbar.mode === 'multi-line'" :timeout="snackbar.timeout" :vertical="snackbar.mode === 'vertical'">
						{{ snackbar.text }}
						<v-btn dark text @click="snackbar.snackbar = false"> Chiudi </v-btn>
					</v-snackbar>
				</v-layout>
			</v-container>
		</v-main>

		<v-dialog v-model="dialogconfirm" max-width="340">
			<v-card>
				<v-card-title class="headline"> Sei sicuro? </v-card-title>
				<v-card-text class="text-left">
					Il documento <b>{{ form && form.name }}</b> verrà eliminato insieme al file allegato e non potrà più essere ripristinato.
				</v-card-text>

				<v-card-actions>
					<v-spacer />

					<v-btn color="primary" text @click="dialogconfirm = false"> Annulla </v-btn>

					<v-btn color="primary" text @click="confirmDelete"> Elimina </v-btn>
				</v-card-actions>
			</v-card>
		</v-dialog>

		<!-- Ultimo elemento: il nodo viene spostato in `[data-app]` al montaggio. -->
		<TourOverlay :tour="tour"></TourOverlay>
	</div>
</template>

<script>
import _ from 'lodash';
import axios from 'axios';
import { mapGetters, mapMutations, mapActions } from 'vuex';
import TourOverlay from '@/components/core/tour/TourOverlay.vue';
import KeyValueCard from '@/components/core/KeyValueCard.vue';
import { useTour } from '@/components/core/tour/useTour';
import { listRouteState } from '@/components/core/list/listRouteState';
import { createDocumentsTourSteps } from './documents-tour';

const LIST_SIZE = [15, 25, 50, 100];

export default {
	name: 'DocumentsIndex',
	// pagina, righe, ordinamento e filtri stanno nell'URL: refresh e ritorno dalle schede ripartono da li'
	mixins: [listRouteState({ filters: { period: 'string', receiver: 'string', downloaded: 'string' }, perPageOptions: LIST_SIZE })],
	setup() {
		return { tour: useTour(createDocumentsTourSteps()) };
	},
	components: {
		KeyValueCard,
		TourOverlay,
	},
	data() {
		return {
			title: this.$vuetify.lang.t('$vuetify.front.documents.list'),
			dialogconfirm: false,
			form: null,

			readOnly: this.$store.getters['profile/getRole'] === 2,

			headers: [
				// colonna del menu a tre puntini: non si ordina
				{ text: '', value: '', sortable: false },
				{ text: 'Data Invio', value: 'created_at' },
				{ text: 'Titolo', value: 'name' },
				{ text: 'Mittente', value: 'sender.name' },
				{ text: 'Destinatario', value: 'receiver.name' },
				{ text: 'Scaricato', value: 'downloaded' },
			],

			listSize: LIST_SIZE,
			total: 0,

			menuPeriod: false,
			receiversList: [],
			downloadedOptions: [
				{ text: 'Scaricati', value: 'yes' },
				{ text: 'Non scaricati', value: 'no' },
			],
			settings: this.listSettingsFromRoute({
				search: '',
				filters: {
					period: '',
					receiver: '',
					downloaded: '',
				},
				options: {
					sortBy: ['created_at'],
					sortDesc: [true],
					page: 1,
					itemsPerPage: 15,
				},
			}),

			snackbar: {
				snackbar: false,
				color: '',
				mode: '',
				timeout: 6000,
				text: '',
			},
		};
	},
	computed: {
		// sotto i 769px le righe diventano card
		mobileCards() {
			return this.$vuetify.breakpoint.width < 769;
		},
		...mapGetters({
			getToken: 'profile/getToken',
			getUrl: 'settings/getUrl',
			getItems: 'documents/getItems',
			getMyUnreadDocuments: 'documents/getMyUnreadDocuments',
			getUsers: 'users/getUsers',
		}),
	},
	async created() {
		this.setExistFilter(true);
		this.listLoad();
		if (!this.readOnly) {
			await this.fetchUsers();
			this.receiversList = _.orderBy(
				(this.getUsers || []).map(u => ({ name: u.name, id: u._id })),
				['name'],
				['asc'],
			);
		}
	},
	beforeDestroy() {
		// Se si lascia la pagina a giro aperto, vanno staccati i listener del tutorial.
		this.tour.stop();
		this.destroyData();
	},
	methods: {
		// stessi dati delle colonne Data Invio/Mittente/Destinatario della tabella desktop
		campiCard(item) {
			return [
				{ label: 'Data invio', value: item.created_at ? new Date(item.created_at).toLocaleString() : '' },
				{ label: 'Mittente', value: item.sender && item.sender.name },
				{ label: 'Destinatario', value: item.receiver && item.receiver.name },
			];
		},
		...mapMutations({
			setPreload: 'settings/setPreload',
			setExistFilter: 'settings/setExistFilter',
			setMyUnreadDocuments: 'documents/setMyUnreadDocuments',
		}),
		...mapActions({
			fetchItems: 'documents/asyncFetchData',
			destroyData: 'documents/destroyData',
			deleteItems: 'documents/deleteItems',
			fetchUsers: 'users/asyncFetchUsers',
		}),
		pickPeriod(value) {
			this.settings.filters.period = value || '';
			this.menuPeriod = false;
		},
		// inserimento, modifica e dettaglio sono pagine: la lista resta nel suo URL e ci si torna uguale
		createItem() {
			this.$router.push('/documents/new');
		},
		editItem(item) {
			this.$router.push(`/documents/${item._id}`);
		},
		showItem(item) {
			this.$router.push(`/documents/${item._id}`);
		},
		downloadFile(item) {
			// la finestra si apre subito, nel click: aperta dopo la risposta del server il browser la blocca
			window.open(item.file, '_blank');
			const wasDownloaded = item.downloaded;
			axios.post(`${this.getUrl}documents/mark-as-downloaded`, { _id: item._id }, { headers: { Authorization: `Bearer ${this.getToken}` } }).then(({ data }) => {
				item.downloaded = data.data.downloaded;
				item.downloaded_at = data.data.downloaded_at;
				if (!wasDownloaded) {
					this.setMyUnreadDocuments(Math.max(0, (+this.getMyUnreadDocuments || 0) - 1));
				}
			});
		},
		// ritorna la promessa: confirmDelete aspetta il ricaricamento prima del messaggio
		getDataFromApi() {
			this.setPreload(true);
			return this.fetchItems(this.settings)
				.then(result => {
					this.total = (result && result.total) || 0;
				})
				.catch(err => {
					console.log(err);
				})
				.finally(() => {
					this.setPreload(false);
				});
		},
		deleteItem(item) {
			this.form = item;
			this.dialogconfirm = true;
		},
		confirmDelete() {
			this.dialogconfirm = false;
			// solo il documento scelto dai tre puntini
			if (!this.form || !this.form._id) return;
			this.setPreload(true);
			this.deleteItems([{ _id: this.form._id }])
				.then(() => this.getDataFromApi())
				.then(() => {
					this.snackbar.color = 'success';
					this.snackbar.text = 'Documento eliminato';
					this.snackbar.snackbar = true;
					this.snackbar.mode = 'multi-line';
					this.snackbar.timeout = 5000;
				})
				.catch(error => {
					console.log(error);
				})
				.finally(() => {
					this.setPreload(false);
				});
		},
	},
};
</script>

<style scoped>
/* vista card: niente layout a colonne, ogni riga e' un blocco e la card prende il 100% */
.table-cards ::v-deep table {
	display: block;
	width: 100%;
}
.document-cards,
.document-cards tr {
	display: block;
	width: 100%;
}
.document-cards tr,
.document-cards tr:hover {
	background: transparent !important;
}
.document-cards td {
	display: block;
	width: 100%;
	border-bottom: none !important;
	height: auto !important;
}
/* respiro tra le card e il bordo della card che contiene la tabella */
.document-cards tr:first-child td {
	padding-top: 12px !important;
}
.document-cards tr:last-child td {
	padding-bottom: 12px !important;
}
.document-cards tr + tr td {
	padding-top: 8px !important;
}
</style>
